import clsx from "clsx";
import React from "react";

import styles from "./CircleStepIndicator.module.scss";

interface CircleStepIndicatorProps {
	isActive?: boolean;
}

export const CircleStepIndicator: React.FC<CircleStepIndicatorProps> = ({ isActive = false }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="8"
			height="8"
			viewBox="0 0 8 8"
			fill="none"
			className={clsx({ [styles.active]: isActive, [styles.inactive]: !isActive })}
		>
			<circle cx="4" cy="4" r="4" />
		</svg>
	);
};
